"use client";
import { setHamburgerState, setMenuTitles, useLazyGetPagesQuery } from "@/store";
import { typeCheck } from "@/utils";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DropdownMenu } from "./DropdownMenu";

export const Navigation = ({ type, lang }) => {
  const { menuTitles } = useSelector((state) => state.common);
  const t = useTranslations();
  const dispatch = useDispatch();
  const router = useRouter();

  let site_type = 0;

  const isBrowser = () => typeof window !== "undefined";
  if (isBrowser()) {
    const windowObject = window.location.hostname.replace(/^www\./, "");
    if (windowObject == "sayt.az" || windowObject == "localhost") {
      site_type = 0;
    } else if (windowObject == "websiteca.com") {
      site_type = 1;
    }
  }

  const [getPages, { data }] = useLazyGetPagesQuery();

  useEffect(() => {
    getPages();
  }, [lang]);
  const navigation = [
    // {
    //   id: "createwebsite",
    //   name: `${t("createwebsite")}`,
    //   to: typeCheck(site_type, ["https://site.az/website", "https://ureb.com/website"]),
    //   dropDown: false,
    //   target_blank: true
    // },
    { id: "website", name: `${t("website")}`, to: typeCheck(site_type, ["/sayt", "/website"]), dropDown: true, },
    { id: "domain", name: `${t("domain")}`, to: "/domain", dropDown: true, },
    { id: "hosting", name: `${t("hosting")}`, to: "/vps-hosting", dropDown: true, },
    { id: "services", name: `${t("services")}`, to: "/", dropDown: true },
    { id: "company", name: `${t("company")}`, to: "/", dropDown: true },
  ];
  const classes = {
    desktop:
      "text-base text-mainDarkPurple font-manrope font-bold flex justify-center items-center gap-[3px]",
    mobile:
      "mx-3 block rounded-lg px-3 py-2 text-base leading-7 text-mainDarkPurple font-bold hover:bg-gray-50 flex items-center",
  };

  const menuHandler = (e, { to, dropDown, id }) => {
    e.stopPropagation();
    if (dropDown) {
      dispatch(setMenuTitles(id));

    } else {
      dispatch(setMenuTitles(""));
      dispatch(setHamburgerState(false));
      router.push(to);
    }
  };

  function getCookie(cookieName) {
    let cookieValue;

    if (typeof window !== "undefined") {
      cookieValue = window.document.cookie
        .split("; ")
        .find((row) => row.startsWith(cookieName))
        ?.split("=")[1];
    }

    return cookieValue ? decodeURIComponent(cookieValue) : "en";
  }

  const nextLocaleCookie = getCookie("NEXT_LOCALE") || "en";

  return (
    <>
      {
        <>
          {navigation?.map(({ name, to, dropDown, id, target_blank }, index) => {
            return dropDown ? (
              <div
                key={index}
                className={`${classes[type]} relative cursor-pointer group `}
                onClick={(e) => menuHandler(e, { to, dropDown, id })}
              >
                <span className="mr-[2px] whitespace-nowrap group-hover:text-mainLightPurpleHover">{name}</span>
                {id === menuTitles && (
                  <DropdownMenu
                    data={data}
                    types={type}
                    locales={nextLocaleCookie}
                    name={menuTitles}
                  />
                )}
                <ChevronDownIcon className="w-5 h-5 group-hover:text-mainLightPurpleHover" />
                {/* <span>
                  <Image
                    src="/icons/chevron_down.svg"
                    width={16}
                    height={16}
                    onClick={(e) => menuHandler(e, { to, dropDown, id })}
                    alt="Vektor"
                  />
                </span> */}
              </div>
            ) : (

              <Link
                locale={nextLocaleCookie}
                prefetch={true}
                href={`${to}`}
                key={index}
                target={target_blank ? "blank" : "_self"}
                className={`${classes[type]} relative cursor-pointer hover:text-mainLightPurpleHover`}
              >
                <span
                  onClick={() => dispatch(setHamburgerState(false))}
                  className="mr-[2px] whitespace-nowrap"
                >
                  {name}
                </span>
              </Link>
            );
          })}
        </>
      }
    </>
  );
};
